import { TradeHistory } from "../components/TradeHistory";

export function HistoryPage() {
  return (
    <div className="page">
      <div className="page-head">
        <h1 className="page-title">Transaction history</h1>
      </div>
      <TradeHistory />
    </div>
  );
}
